import { Injectable } from '@angular/core';

import CryptoJS from 'crypto-js';
import { filter } from 'rxjs';

import { UserHttpService } from '@shared/services-http/user-http.service';
import { UserViewModel } from '@shared/view-models/user.viewmodel';


declare global {
  interface Window {
    Tawk_API: any;
  }
}

@Injectable({
  providedIn: 'root'
})
export class TawkToChatService {

  private readonly API_TAWK_TO_KEY = '22287d4d4c8ba1a062f0bc8b5793552537106a95';

  constructor(
    private userHttpService: UserHttpService,
  ) {}

  public hideChat(): void {
    window.Tawk_API.minimize();
    window.Tawk_API.hideWidget();
  }

  public showWidgetAndChat(): void {
    window.Tawk_API.maximize();
  }

  public onStatusChange(): void {
    window.Tawk_API.onStatusChange = (status: string) => {
      if (status === 'online') {
        this.hideChat();
      }
    };
    window.Tawk_API.onLoad = () => {
      this.onLoadUserData();
    };
  }

  public initAttributesUser(userViewModel: UserViewModel): void {
    window.Tawk_API.setAttributes({
        'name'  : userViewModel.getFullName(),
        'email' : userViewModel?.user.Email,
        'phone' : userViewModel?.user.Phone,
        'hash'  : 'hash value'
    }, (err: any) => {});
  }

  private onLoadUserData(): void {
    this.userHttpService.userData$.pipe(filter(data => data !== null)).subscribe((data) => {
      this.initAttributesUser(data);
      this.login(data);
    });
  }

  private hashInBase64(userId:string): string {
    var hash = CryptoJS.HmacSHA256(userId, this.API_TAWK_TO_KEY);
    return CryptoJS.enc.Hex.stringify(hash);
  }

  public login(userViewModel: UserViewModel): void {
    console.log(userViewModel);

    const userId = String(userViewModel?.user.UserId);
    const hash = this.hashInBase64(userId);

    window.Tawk_API.login({
      hash,
      userId,
    },
    function (error: any) {
      if (error) {
        console.log('ERROR LOGIN TAWK:', error);
      } else {
        console.log('Logged in successfully');
      }
    });
  }

}
